document.addEventListener('DOMContentLoaded', () => {
  const filterItems = document.querySelectorAll('.filter-item');
  let activeFilters = new URLSearchParams(window.location.search);

  function updateAppearance() {
    filterItems.forEach((item) => {
      const filter = item.dataset.filter;
      item.classList.toggle('active', activeFilters.toString().includes(filter));
    });
  }

  async function fetchProductsAndFilters() {
    try {
      const url = window.location.pathname + (activeFilters.toString() ? '?' + activeFilters.toString() : '');
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-search-results], .product-grid, #main-collection-product-grid');
      const grid = document.querySelector('[data-search-results], .product-grid, #main-collection-product-grid');
      if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;

      const newFilters = doc.querySelector('#FacetFiltersForm');
      const currentFilters = document.querySelector('#FacetFiltersForm');
      if (newFilters && currentFilters) currentFilters.innerHTML = newFilters.innerHTML;

      window.history.replaceState({}, '', url);
    } catch (err) {
      window.location.href = window.location.pathname + '?' + activeFilters.toString();
    }
  }

  filterItems.forEach((item) => {
  item.addEventListener('click', (e) => {
    const href = item.getAttribute('href');
    if (href && href !== '#' && href !== '') {
      // tem link configurado: navega normalmente
      return;
    }
    e.preventDefault();
    const filter = item.dataset.filter;
    if (activeFilters.toString().includes(filter)) activeFilters = new URLSearchParams();
    else activeFilters = new URLSearchParams(filter);
    updateAppearance();
    fetchProductsAndFilters();
  });
});

  updateAppearance();

  const toggleButton = document.getElementById('filter-toggle');
  const filterList = document.getElementById('filter-list');
  if (!toggleButton || !filterList) return;

  toggleButton.addEventListener('click', () => {
    filterList.classList.toggle('expanded');

    const moreText = toggleButton.dataset.moreText;
    const lessText = toggleButton.dataset.lessText;

    toggleButton.textContent = filterList.classList.contains('expanded')
      ? lessText
      : moreText;
  });
});